import api from './api.js';

class Auth {
    constructor() {
        this.url_login         = 'account/login';
        this.url_logout        = 'account/logout';
        this.url_current_user  = 'account/users/current';
        this.url_activate_user = 'users/activate';
    }

    login(data){
        return api.post(this.url_login, data, {'Content-Type': 'application/x-www-form-urlencoded'});
    }

    logout(){
        return api.delete(this.url_logout,{});
    }

    currentUser(){
        return new Promise((resolve, reject) => {
            api.get(this.url_current_user).then(res => {
                resolve(res);
            }).catch(err => {
                // Handle 403/401 errors gracefully for currentUser calls
                // This is expected when user is not authenticated
                if (err.response && (err.response.status === 403 || err.response.status === 401)) {
                    // Don't log to console for expected authentication failures
                    reject(new Error('User not authenticated'));
                } else {
                    // Log other unexpected errors
                    console.error('Unexpected error getting current user:', err);
                    reject(err);
                }
            });
        });
    }

    activateUser(data){
        return api.post(this.url_activate_user,data);
    }
    
}

export default new Auth;
